import { render, staticRenderFns } from "./ExportConfigMenu.vue?vue&type=template&id=135d62a5&"
import script from "./ExportConfigMenu.vue?vue&type=script&lang=js&"
export * from "./ExportConfigMenu.vue?vue&type=script&lang=js&"
import style0 from "./ExportConfigMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports